









import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class DiagramLegendNoCard extends Vue {
  @Prop({required: true, type: Array})
  items!: [];
}
